export const FORBIDDEN_OPERATION_ERROR = 403;
